module.exports = __webpack_public_path__ + "static/img/数字孪生.a579f94.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/数字孪生.jpg
// module id = jm7y
// module chunks = 1